

export default (): [number, number] => {
	const lon = +(Math.random() * 360 - 180).toFixed(3); // -180 to 180
	const lat = +(Math.random() * 180 - 90).toFixed(3); // -90 to 90
	return [lon, lat];
};

